import { render, staticRenderFns } from "./InProcessCard.vue?vue&type=template&id=38f4a422"
import script from "./InProcessCard.vue?vue&type=script&lang=js"
export * from "./InProcessCard.vue?vue&type=script&lang=js"
import style0 from "./InProcessCard.vue?vue&type=style&index=0&id=38f4a422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports